let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ZJGz")).then(() => parcelRequire('1eEyb'));